import {Component, ViewChild} from '@angular/core';
//import {Http} from '@angular/http';

import { DataTable } from './../../../services/DataTable';
import * as moment from 'moment';
import {LeadImportsService} from "../../../models/leads/leadImports.service";
//import {BadgesService} from "../../../models/badges/badges.service";
//import {BadgesHelper} from "../../../services/BadgesHelper";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {dateTimeHelper} from "../../../helpers/date";
// import { Router } from '@angular/router';

@Component({
    selector: 'import-list',
    templateUrl: 'template.html',
    styleUrls: ['style.css']
})
export class ImportListComponent {
    @ViewChild('confirmDialogDelete') public confirmDialogDelete;

    dataTable: DataTable;

    constructor(
        private service: LeadImportsService,
        //public badgesService: BadgesService,
        //public badgesHelper: BadgesHelper,
        public toasterService: ToasterService,
    ) {
        this.dataTable = new DataTable(this.service);
        this.dataTable.fetch();
    }

    ngOnInit() {
        
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

    itemId: any;
    public deleteInProcess = false;

    deleteItem(entry) {
        if (! entry || ! entry.id) return;
        this.itemId = entry.id;
        if (this.deleteInProcess) return;
        this.confirmDialogDelete.show('Do you want delete item #' + this.itemId + '?');
    }

    applyDeleteItem() {
        if (this.deleteInProcess) return;
        this.deleteInProcess = true;
        this.service.remove(this.itemId)
            .subscribe(
                (res) => {
                    this.deleteInProcess = false;
                    this.toasterService.pop('success', 'Success', 'Deleted');

                    this.dataTable.refresh();
                },
                (error) => {
                    this.deleteInProcess = false;
                    this.toasterService.pop('error', 'Error', 'Error. Try again');
                }
            );
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/import-list/component.ts